import React from "react";

const Space = ({ height, width }) => {
  return (
    <div
      style={
        width
          ? { width: width, display: "inline-block", height: height, lineHeight: height }
          : { height: height, lineHeight: height }
      }>
      &nbsp;
    </div>
  );
};

export default Space;
